import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector, getUnreadCountThunk, getChatInboxThunk } from "../../redux";
import { ROUTES } from "../../constants";
import bellIcon from "../../assets/icons/bell.svg";
import "./NotificationBell.css";

const NotificationBell: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const role = useAppSelector((state) => state.auth.role);
  const unreadCount = useAppSelector((state) => state.chat.unreadCount);

  useEffect(() => {
    dispatch(getUnreadCountThunk());
    const interval = setInterval(() => {
      dispatch(getUnreadCountThunk({ force: true }));
    }, 60000);
    return () => clearInterval(interval);
  }, [dispatch]);

  const handleBellClick = () => {
    dispatch(getChatInboxThunk({ force: true }));
    if (role === "teacher") {
      navigate(ROUTES.TEACHER.INBOX);
    } else {
      navigate(ROUTES.STUDENT.INBOX);
    }
  };

  return (
    <div className="notification-bell-container">
      <button
        type="button"
        className="notification-bell-btn"
        onClick={handleBellClick}
        aria-label="Chat Notifications"
        title={`${unreadCount} Unread Message(s)`}
      >
        <img src={bellIcon} alt="Notifications" width={20} height={20} />

        {unreadCount > 0 && (
          <span className="notification-badge">
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>
    </div>
  );
};

export default NotificationBell;
